const headerWrapper = document.querySelector('.header-wrapper')
const headerLayer = document.querySelector('.header__layout')

handleNavColors()
document.addEventListener('scroll', handleNavColors)

function handleNavColors() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;


	if(scrollTop > 100){

		headerLayer.classList.add("filled")
		headerWrapper.classList.remove('white')
	}else{
		headerLayer.classList.remove("filled")
		headerWrapper.classList.add('white')
	}
}


const drawerSearchClearBtn = document.querySelector('.search-clear')
const drawerSearchInput = document.querySelector('.drawer-search__input')
const searchInputs = [...document.querySelectorAll('.search__input')]
const searchLabels = [...document.querySelectorAll('.search__label')]



searchInputs.forEach(input => {
	input.addEventListener('focus', () => {
			searchLabels.forEach(label => label.classList.add('is-hidden'))
	})
})

searchInputs.forEach(input => {
	input.addEventListener('blur', () => {
			searchLabels.forEach(label => label.classList.remove('is-hidden'))
	})
})

drawerSearchClearBtn.addEventListener('click', () => {
	drawerSearchInput.value = ''
	drawerSearchInput.focus()
})